import { automationPaginator } from '../paginators';
import { DEFAULT_PAGE_SIZE } from '../common';
import { ENV } from '../config';

const { API_ENV } = ENV;

export const requestAutomationListPage = (pageNo) => automationPaginator.automation.requestPage(pageNo, `nodetree/${API_ENV}/root/list?count=${DEFAULT_PAGE_SIZE}`);
